import { Menu, MenuItem, Pressable, View } from "@gluestack-ui/themed";
import React from "react";
import { MenuProps } from "@components/atoms/Menu/types";
import styled, { useTheme } from "styled-components/native";
import VDBIcon, { IconsVariant } from "@components/icons/VDBIcon";
import { Platform } from "react-native";
import useThreeDotMenuState from "../../../hooks/useThreeDotMenuState";
import { IconState } from "@components/molecules/IconUtils";
import { VDBIcons } from "@utils/VDBIcons";
import { VDBText } from "..";
import { ProductCategory } from "@utils/constants";
import { DefaultTheme } from "styled-components/native";

const VDBMenu = ({ options, onActionSelect, data, typography }: MenuProps) => {
  const theme = useTheme();

  const {
    setThreeDotMenuOpen,
    setThreeDotIconState,
    handlePressIn,
    handlePressOut,
    handlePress,
    getThreeDotIconBackgroundColor,
  } = useThreeDotMenuState(false);

  const handleSelectionChange = (keys: any) => {
    const selectedOption = options.find(
      (option: any) => option.key === keys.key
    );
    if (selectedOption && selectedOption.action) {
      onActionSelect(selectedOption.action, data);
    }
  };

  return (
    <Menu
      mt={Platform.OS === "ios" ? 0 : -35}
      borderRadius={12}
      backgroundColor={theme["core-01"]}
      placement="bottom left"
      marginLeft={-8}
      selectionMode="single"
      onOpen={() => {
        setThreeDotMenuOpen(true);
        setThreeDotIconState(IconState.Selected);
      }}
      onClose={() => {
        setThreeDotMenuOpen(false);
        setThreeDotIconState(IconState.Unselected);
      }}
      trigger={({ ...triggerProps }) => {
        return (
          <Pressable
            onPressIn={handlePressIn}
            onPressOut={handlePressOut}
            onPress={handlePress}
            {...triggerProps}
          >
            <VDBIcon
              name={VDBIcons.DOTS_MENU_FILLED}
              size={24}
              color={getThreeDotIconBackgroundColor(
                theme,
                ProductCategory.DEFAULT
              )}
              variant={IconsVariant.VDBCustom}
            />
          </Pressable>
        );
      }}
    >
      {options.map((option: any, index: number) => (
        <MenuItem
          key={option.key}
          textValue={option.key}
          style={{ padding: 0 }}
          onPress={() => {
            handleSelectionChange(option);
          }}
        >
          <View>
            {index !== 0 && <LineView theme={theme} />}
            <MenuItemStyle>
              <VDBText
                color={theme[option.fontColor as keyof DefaultTheme] as string}
                type={typography}
              >
                {option.label}
              </VDBText>
            </MenuItemStyle>
          </View>
        </MenuItem>
      ))}
    </Menu>
  );
};

const LineView = styled.View<any>`
  height: 1px;
  background-color: ${({ theme }: { theme: DefaultTheme }) => theme["core-03"]};
  width: auto;
`;

const MenuItemStyle = styled.View`
  border-color: #000000;
  width: 250px;
  padding: 12px;
`;

export default VDBMenu;
